/**
 * i18nClass
 */

import { I18NClass, Language_Token_key, LangOpts } from "./I18NClass";

const i18nCtx = I18NClass.getInstance();

export { i18nCtx, Language_Token_key, LangOpts };
